webpackJsonp([278241087454979],{

/***/ 181:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 150:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(181);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Copyright (c) Meta Platforms, Inc. and affiliates.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 * @format
	 */
	
	exports.default = function (props) {
	  return _react2.default.createElement(
	    'div',
	    { className: 'Padded ' + (props.className || '') },
	    props.children
	  );
	};
	
	module.exports = exports['default'];

/***/ }),

/***/ 524:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 426:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _row = __webpack_require__(43);
	
	var _row2 = _interopRequireDefault(_row);
	
	var _col = __webpack_require__(37);
	
	var _col2 = _interopRequireDefault(_col);
	
	__webpack_require__(44);
	
	__webpack_require__(38);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(58);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _Page = __webpack_require__(151);
	
	var _Page2 = _interopRequireDefault(_Page);
	
	var _Padded = __webpack_require__(150);
	
	var _Padded2 = _interopRequireDefault(_Padded);
	
	__webpack_require__(524);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CATEGORY_TITLE = {
	  'getting-started': 'Getting Started',
	  properties: 'Properties',
	  examples: 'Examples',
	  contributing: 'Contributing'
	}; /**
	    * Copyright (c) Meta Platforms, Inc. and affiliates.
	    *
	    * This source code is licensed under the MIT license found in the
	    * LICENSE file in the root directory of this source tree.
	    *
	    * 
	    * @format
	    */
	
	exports.default = function (_ref) {
	  var data = _ref.data;
	  return _react2.default.createElement(
	    _Page2.default,
	    { className: 'docs-landing', shouldShowFooter: true, title: 'Documentation' },
	    _react2.default.createElement(
	      _Padded2.default,
	      null,
	      _react2.default.createElement(
	        _row2.default,
	        { className: 'heading' },
	        _react2.default.createElement(
	          _col2.default,
	          { xl: 16, lg: 16, md: 24, sm: 24, xs: 24 },
	          _react2.default.createElement(
	            'h1',
	            null,
	            'Documentation'
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            'Welcome to Yoga\'s documentation page. Below you will find helpful documentation covering all the features of the library. Each page comes with an interactive playground for you to explore that feature. The examples section showcases some of the most common layouts and how to build them. This is a community project and contributions within documentation, code, and tests are more than welcome. The contributing section below covers how to get started.'
	          )
	        )
	      ),
	      _react2.default.createElement(
	        _row2.default,
	        null,
	        ['getting-started', 'properties', 'examples', 'contributing'].map(function (category) {
	          return _react2.default.createElement(
	            _col2.default,
	            { lg: 6, md: 12, xs: 24, key: category, className: 'category' },
	            _react2.default.createElement(
	              'h2',
	              null,
	              CATEGORY_TITLE[category]
	            ),
	            data.allMarkdownRemark.edges.filter(function (_ref2) {
	              var node = _ref2.node;
	              return node.fileAbsolutePath.indexOf('/' + category + '/') > -1;
	            }).map(function (_ref3) {
	              var node = _ref3.node;
	              return node.frontmatter.redirect ? _react2.default.createElement(
	                'a',
	                { key: node.id, href: node.frontmatter.path },
	                node.frontmatter.title
	              ) : _react2.default.createElement(
	                _gatsbyLink2.default,
	                { key: node.id, to: node.frontmatter.path },
	                node.frontmatter.title
	              );
	            })
	          );
	        })
	      )
	    )
	  );
	};
	
	var query = exports.query = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-docs-index-js-4eea7564867d122e03c7.js